import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle } from 'lucide-react';

const EngineerSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Optionally verify session with backend
    if (!sessionId) {
      navigate('/engineer/dashboard');
    }
  }, [sessionId, navigate]);

  return (
    <div className="success-page">
      <div className="container">
        <Card className="success-card-large">
          <CardContent className="success-content-large">
            <CheckCircle size={80} className="success-icon-large" />
            <h1>Payment Successful!</h1>
            <p className="success-message">
              Thank you! Your subscription is now active and your listing is LIVE on The Gas Guide.
            </p>
            <div className="success-details">
              <h3>What happens next:</h3>
              <ul>
                <li>✓ Your profile is now visible to homeowners in your coverage areas</li>
                <li>✓ Customers can contact you directly</li>
                <li>✓ You'll receive a confirmation email shortly</li>
                <li>✓ Start building your customer reviews</li>
              </ul>
            </div>
            <Button 
              className="btn-primary btn-large"
              onClick={() => navigate('/engineer/dashboard')}
            >
              Go to Dashboard
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default EngineerSuccess;
